import { buildSnapshotXml, deriveRegion } from "@/components/Copilot/snapshot"

export type PageSnapshotFilter = (el: Element, key: string) => boolean

export function collectFieldValue(el: Element): string {
  const selfAttr = (el as HTMLElement).getAttribute("data-copilot-value")
  if (typeof selfAttr === "string" && selfAttr.length > 0) return selfAttr
  const valueEl = el.querySelector("[data-copilot-value]") as HTMLElement | null
  if (valueEl && valueEl.getAttribute("data-copilot-value")) {
    return valueEl.getAttribute("data-copilot-value") || ""
  }

  const tag = (el as HTMLElement).tagName.toLowerCase()
  if (tag === "input" || tag === "textarea") {
    const anyEl = el as HTMLInputElement
    return anyEl.value || anyEl.textContent || ""
  }
  const inner = el.querySelector(
    "input, textarea, [contenteditable='true'], [role='textbox'], [role='switch']"
  ) as HTMLInputElement | HTMLTextAreaElement | HTMLElement | null
  if (inner) {
    if ((inner as HTMLElement).getAttribute("role") === "switch") {
      const v = (inner as HTMLElement).getAttribute("aria-checked")
      return v === "true" ? "true" : "false"
    }
    if (inner instanceof HTMLInputElement && inner.type === "checkbox") {
      return inner.checked ? "true" : "false"
    }
    if (
      inner instanceof HTMLInputElement ||
      inner instanceof HTMLTextAreaElement
    ) {
      return inner.value || inner.textContent || ""
    }
    return inner.textContent || ""
  }
  return (el.textContent || "").trim()
}

export function buildPageSnapshotXml(params: {
  pageKey: string
  filter?: PageSnapshotFilter
  fieldSelector?: string
}): string {
  const { pageKey, filter, fieldSelector = "[data-copilot-field]" } = params

  const createdAtIso = new Date().toISOString()
  const pageUrl = window.location.href
  const pageTitle = document.title

  const viewport = { width: window.innerWidth, height: window.innerHeight }
  const fields: { key: string; value?: string; region?: string }[] = []

  const sel = document.querySelectorAll(fieldSelector)
  sel.forEach((el) => {
    const key = el.getAttribute("data-copilot-field") || undefined
    if (!key) return
    if (filter && !filter(el, key)) return

    try {
      const r = el.getBoundingClientRect()
      const x = Math.max(0, Math.round(r.left))
      const y = Math.max(0, Math.round(r.top))
      const w = Math.max(0, Math.round(r.width))
      const h = Math.max(0, Math.round(r.height))
      const region = deriveRegion(viewport, { x, y, width: w, height: h })
      const value = collectFieldValue(el)
      fields.push({ key, value, region })
    } catch (_) {
      // ignore failures to measure; still capture value
      const value = collectFieldValue(el)
      fields.push({ key, value })
    }
  })

  return buildSnapshotXml({
    pageKey,
    pageUrl,
    pageTitle,
    createdAtIso,
    fields,
    viewport,
  })
}
